import "core-js/modules/es6.regexp.replace.js";
import analytics from '@nerdwallet/analytics';
export var buildAnalyticsEntityName = function buildAnalyticsEntityName(name) {
  return name === null || name === void 0 ? void 0 : name.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};

var trackCarouselInteracted = function trackCarouselInteracted(id, impression, interactionType, entityName) {
  var payload = {
    action: 'browse',
    interaction_type: interactionType,
    impression_id: impression === null || impression === void 0 ? void 0 : impression.impressionId
  };

  if (!(impression !== null && impression !== void 0 && impression.impressionId) || entityName) {
    var name = entityName || id;
    payload.entity_name = buildAnalyticsEntityName("carousel_".concat(name));
  }

  analytics.track('element_interacted', payload);
};

export default trackCarouselInteracted;